import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../utils/api";

// Async thunk to fetch all files
export const fetchFiles = createAsyncThunk(
  "files/fetchFiles",
  async (_, { rejectWithValue }) => {
    try {
      const response = await get("/files/");
      return response.data.files || [];
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState = {
  list: [],
  isLoading: false,
  error: null,
};

const filesSlice = createSlice({
  name: "files",
  initialState,
  reducers: {
    // Add a file to the list
    addFile(state, action) {
      state.list.unshift(action.payload);
    },
    // Remove a file from the list
    removeFile(state, action) {
      state.list = state.list.filter((f) => f.id !== action.payload);
    },
    // Clear all files data (for logout)
    clearFiles(state) {
      state.list = [];
      state.isLoading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFiles.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchFiles.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = action.payload;
      })
      .addCase(fetchFiles.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { addFile, removeFile, clearFiles } = filesSlice.actions;

export default filesSlice.reducer;

